import { createApiRef } from '@backstage/core-plugin-api';

export const surveyJSApiRef = createApiRef<SurveyJSApi>({
  id: 'plugin.surveyjs.service',
});

export interface SurveyJSApi {
  getSurveyList(): Promise<any>;
  getSurvey(id: number): Promise<any>;
  deleteSurvey(id: number): Promise<any>;
  getSurveyResponses(id: number): Promise<any>;
  getSurveySchema(id: number): Promise<any>;
  submitSurveyResponse(
    id: number,
    responses: any,
    userId: string,
  ): Promise<any>;
  saveSurvey(surveyJSON: any, title: string): Promise<any>;
  saveEditedSurvey(id: number, surveyJson: any, title: string): Promise<any>;
  updateSurveyResponse(
    surveyId: number,
    responseId: number,
    response: any,
  ): Promise<any>;
}
